import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=3a38b467&scoped=true"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"
import style0 from "./Notification.vue?vue&type=style&index=0&id=3a38b467&prod&lang=scss&scoped=true"
import style1 from "./Notification.vue?vue&type=style&index=1&id=3a38b467&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a38b467",
  null
  
)

export default component.exports